import styled from 'styled-components';

export const MapChartContainer = styled.div`
  flex: 1;
  max-width: 624px;

  & > div {
    margin-left: 80px;

    width: 468px;
    height: 458px;
  }

  @media (max-width: 768px) {
    width: 100%;

    & > div {
      margin: 0 auto;
      width: 80vw;
    }
  }
`;
